export default "__VITE_ASSET__Djw0EA$y__"